(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avantages-produit"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.target-inch-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 15,
      freeMode: true,
      grabCursor: true,
      breakpoints: {
        0: {
          slidesPerView: 2.5
        },
        769: {
          slidesPerView: 'auto'
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banniere-produit"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const bgSection = document.querySelector('.bg-section');
  if (!bgSection) return;

  function updateBackgroundImage() {
    const isMobile = window.innerWidth <= 768;
    const newBg = isMobile ? bgSection.dataset.bgMobile : bgSection.dataset.bgDesktop;
    if (newBg) {
      bgSection.style.backgroundImage = `url('${newBg}')`;
    }
  }

  updateBackgroundImage();
  window.addEventListener('resize', updateBackgroundImage);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-text"] && !Shopify.designMode) return;
  try {
    
  
  (function(){
    if (typeof Swiper === 'undefined') { return; }
    var root = document.querySelector('.homepage-icons .mobile-swiper');
    if (!root) { return; }

    if (root.__inited) { return; }
    root.__inited = true;

    new Swiper(root, {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 16,
      autoHeight: true,
      pagination: {
        el: root.querySelector('.swiper-pagination'),
        clickable: true
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".tab-buttons button");
  const items = document.querySelectorAll(".tab-item");

  function updateDisplay(selectedTab) {
    items.forEach(item => {
      const tabs = item.dataset.tabs.split(',').map(t => t.trim().toLowerCase());
      if (tabs.includes(selectedTab)) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  }

  const firstTab = buttons[0]?.dataset.tab.toLowerCase().trim();
  if (firstTab) updateDisplay(firstTab);

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      buttons.forEach(btn => btn.classList.remove("active"));
      button.classList.add("active");
      updateDisplay(button.dataset.tab.toLowerCase().trim());
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photos-txt-arguments"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 768) {
    new Swiper('.sleepy-why__grid', {
      slidesPerView: 1,
      spaceBetween: 16,
      centeredSlides: false,
      navigation: {
        nextEl: `.sleepy-why .sleepy-why__grid .swiper-button-next`,
        prevEl: `.sleepy-why .sleepy-why__grid .swiper-button-prev`,
      },
    });
  }
});
document.addEventListener('DOMContentLoaded', () => {
  const cols = document.querySelectorAll('.sleepy-compare-col');
  if (!cols.length) return;

  const cards = document.querySelectorAll('.sleepy-card');
  const container = document.querySelector('.sleepy-why__container');

  function activate(tab) {
    cols.forEach(col =>
      col.classList.toggle('is-active', col.dataset.tab === tab)
    );

    cards.forEach(card => {
      card.style.display = card.dataset.tab === tab ? '' : 'none';
    });


    if (container) {
      container.classList.toggle('is-tab1', tab === 'tab1');
      container.classList.toggle('is-tab2', tab === 'tab2');
    }

    equalizeSleepyCards();
  }

  cols.forEach(col => {
    col.addEventListener('click', () => activate(col.dataset.tab));
  });

  activate('tab1');
});




function equalizeSleepyCards() {
  const cards = document.querySelectorAll('.sleepy-card__content');
  if (!cards.length) return;

  // reset
  cards.forEach(card => {
    card.style.height = 'auto';
  });

  let maxHeight = 0;

  cards.forEach(card => {
    maxHeight = Math.max(maxHeight, card.offsetHeight);
  });

  cards.forEach(card => {
    card.style.height = maxHeight + 'px';
  });
}

document.addEventListener('DOMContentLoaded', () => {
  equalizeSleepyCards();

  window.addEventListener('resize', () => {
    equalizeSleepyCards();
  });
});

  } catch(e) { console.error(e); }
})();
})();
